import React from 'react'

import type { Color } from '@fourthwall/components'
import { ColorItem } from '@fourthwall/components'

import * as S from './CheckboxColorLabel.styled'

type CheckboxColorLabelProps = {
  label: string
  color?: Color
}

export const CheckboxColorLabel = ({ label, color }: CheckboxColorLabelProps) => (
  <S.Container>
    {color && <ColorItem color={color} />}
    <div>{label}</div>
  </S.Container>
)
